import { render, staticRenderFns } from "./Persona.vue?vue&type=template&id=bd0a4010&scoped=true"
import script from "./Persona.vue?vue&type=script&lang=ts"
export * from "./Persona.vue?vue&type=script&lang=ts"
import style0 from "./Persona.vue?vue&type=style&index=0&id=bd0a4010&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd0a4010",
  null
  
)

export default component.exports